<span class="md-inputfield">
  <!-- [style]="{'width':'100%'}"
  [inputStyle]="{'width':'100%'}" -->
  <p-autoComplete
    name="autocomplete"
    field="nome"
    [(ngModel)]="autocomplete.itemSelecionado"
    [suggestions]="autocomplete.resultset"
    [dropdown]="true"
    [required]="false"
    [disabled]="bloqueado || formDisabled"
    [size]="autocomplete.resultsetMaxSize"
    [forceSelection]="true"
    (completeMethod)="autocomplete.buscarItem($event)"
    (onSelect)="autocomplete.onSelectItem($event);"
    (onClear)="autocomplete.onClearItem()">
  </p-autoComplete>
  <label>{{placeholder}}</label>
  <!-- bloqueado || formDisabled -->
</span>
